import { createRouter, createWebHistory } from 'vue-router';
import LandingPage from '@/components/screens/LandingPage.vue';
import ContactUs from '@/components/screens/ContactUs.vue';
import ReportTypeSelection from '@/components/screens/ReportTypeSelection.vue';
import CyberIncidentScreen from '@/components/screens/CyberIncidentScreen.vue';
import ReportIncident from '@/components/screens/ReportIncident.vue';
import FollowUp from '@/components/screens/FollowUp.vue';
import RecaptchaGate from '@/components/screens/RecaptchaGate.vue';

const routes = [
  {
    path: '/',
    name: 'default',
    redirect: () => {
      const userLang = localStorage.getItem('user-language') || 'en';
      return { path: `/${userLang}/home` };
    }
  },
  {
    path: '/:lang/home',
    name: 'home',
    component: LandingPage,
    meta: { title: 'Home' }
  },
  {
    path: '/:lang/contact',
    name: 'contact',
    component: ContactUs,
    meta: { title: 'Contact Us' }
  },
  {
    path: '/:lang/report-incident',
    name: 'report-incident',
    component: ReportTypeSelection,
    meta: { title: 'Report Incident' }
  },
  {
    path: '/:lang/cyber-incident',
    name: 'cyber-incident',
    component: CyberIncidentScreen,
    meta: { title: 'Cyber Security Incident' }
  },
  {
    path: '/:lang/antic-complaint',
    name: 'antic-complaint',
    component: ReportIncident,
    meta: { title: 'ANTIC Complaint' }
  },
  {
    path: '/:lang/followup',
    name: 'followup',
    component: FollowUp,
    meta: { title: 'Follow Up' }
  },
  {
    path: '/:lang/verify/:type',
    name: 'recaptcha-gate',
    component: RecaptchaGate,
    meta: { title: 'Security Verification' }
  },
  {
    path: '/:path(.*)*',
    redirect: () => {
      const lang = localStorage.getItem('user-language') || 'en';
      return { path: `/${lang}/home` };
    }
  }
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach((to, from, next) => {
  const lang = to.params.lang;
  const validLangs = ['en', 'fr'];

  if (lang && to.name !== 'default' && !validLangs.includes(lang)) {
    const newPath = to.path.replace(/^\/[^/]+/, '/en');
    next(newPath);
    return;
  }

  if (lang && validLangs.includes(lang)) {
    localStorage.setItem('user-language', lang);
  }

  next();
});

router.afterEach((to) => {
  const lang = to.params.lang || 'en';
  const title = to.meta?.title || 'App';
  document.title = `${title} - ${lang.toUpperCase()}`;
});

export default router;